import { inject, Injectable, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export type CustomIconsMap<Name extends string> = {
  [key in Name]: string;
};

@Injectable({
  providedIn: 'root',
})
export class RegisterMatIconsService<Name extends string> {
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  icons!: CustomIconsMap<Name>;

  setupIcons(iconsMap: CustomIconsMap<Name>) {
    this.buildIconNamesObject(iconsMap);
    this.registerIcons(iconsMap);
  }

  private registerIcons(iconsMap: CustomIconsMap<Name>) {
    Object.entries(iconsMap).forEach(([iconName, iconPath]) => {
      this.registericon(iconName, iconPath as string);
    });
  }

  private buildIconNamesObject(iconsMap: CustomIconsMap<Name>) {
    this.icons = Object.keys(iconsMap).reduce((result: CustomIconsMap<Name>, iconName) => {
      result[iconName as Name] = iconName;
      return result;
    }, {} as CustomIconsMap<Name>);
  }

  private registericon(iconName: string, iconPath: string) {
    this.iconRegistry.addSvgIcon(iconName, this.sanitizer.bypassSecurityTrustResourceUrl(iconPath));
  }
}

export const registerMaterialIconsProviderFabric = <Name extends string>(iconsMap: CustomIconsMap<Name>) => (provideAppInitializer(() => {
        const initializerFn = ((iconService: RegisterMatIconsService<Name>) => () => iconService.setupIcons(iconsMap))(inject(RegisterMatIconsService));
        return initializerFn();
      }));
